// Entry SPA GS-Hub — AuthProvider MSAL + ROLE_MAPPINGS (3 groupes Azure AD).
// NB Systeme C : les ROLE_MAPPINGS cote SPA servent l'AFFICHAGE/garde client ; l'AUTORISATION
// reelle est cote serveur (requireAuth + remap HUB_USER_NOT_PROVISIONED). Pas de localStorage.
// i18n importe AVANT le render + GsLocaleProvider AU-DESSUS de tout l'UI (login inclus).
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider, GsRole } from '@gs/auth';
import { ToastProvider, GsPreproductionBanner } from '@gs/ui';
import { GsLocaleProvider } from '@gs/i18n';
import { initTelemetry } from '@gs/telemetry';
import { QueryProvider } from './lib/QueryProvider';
import App from './App';
import './i18n';
// Inter self-hostée (@fontsource-variable/inter) — JAMAIS Google Fonts CDN.
// fontFamily.sans = InterVariable (tailwind.config.shared.js, DS v2.2.0).
import '@fontsource-variable/inter';
import './index.css';

initTelemetry({
  connectionString: import.meta.env.VITE_APPINSIGHTS_CONNECTION_STRING ?? '',
  appKey: 'hub',
  gitSha: import.meta.env.VITE_GS_GIT_SHA,
});

const ROLE_MAPPINGS = [
  { groupId: '7a9bf9f7-dde9-44ff-86c1-deee829462c4', role: GsRole.ADMIN },
  { groupId: 'e1594515-5d26-4b84-b14c-30f69d7d3ae6', role: GsRole.GESTIONNAIRE },
  { groupId: '8dd154cd-c43e-4fd8-aa4f-50f385d94486', role: GsRole.UTILISATEUR },
];

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <GsLocaleProvider>
      {/* Bandeau de preproduction : AU-DESSUS de tout l'UI (connexion et refus compris) ;
          ne rend rien hors de l'emplacement preprod (feat-le-bandeau-de-preproduction). */}
      <GsPreproductionBanner />
      <ToastProvider>
        <QueryProvider>
          <AuthProvider roleMappings={ROLE_MAPPINGS} defaultRole={GsRole.UTILISATEUR} appKey="hub">
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </AuthProvider>
        </QueryProvider>
      </ToastProvider>
    </GsLocaleProvider>
  </React.StrictMode>,
);
